import React from 'react';
import InputField from 'app/components/commonUI/InputField';
import SelectField from 'app/components/commonUI/SelectField';
import SectionIcon from './SectionIcon';
import ErrorIcon from '@mui/icons-material/Error';
import { DURATION_OPTIONS, CATEGORY_OPTIONS } from 'app/services/api/fake_services/menu_management_fake_data';

export default function BasicInfoSection({ values, errors, setFieldValue, readonly = false }) {
  return (
    <div className="px-4 py-6 border-b border-slate-50">
      <SectionIcon title="基本情報">
        <span className="material-symbols-outlined text-primary text-xl">description</span>
      </SectionIcon>

      <div className="space-y-6">
        <label className="block">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-sm font-bold">メニュー名</span>
            {!readonly && (
              <span className="text-[10px] bg-red-50 text-red-500 px-1.5 py-0.5 rounded font-bold">必須</span>
            )}
          </div>
          {!readonly ? (
            <>
              <InputField
                name="name"
                value={values.name}
                placeholder="例：オーガニックヘッドスパ"
                inputClasses={`w-full rounded-xl border h-12 px-4 text-base transition-all 
                  ${errors.name ? 'border-red-500' : 'border-slate-200'}
                `}
                onChange={(value) => setFieldValue('name', value)}
                errors={errors.name}
              />
              {errors.name && (
                <p className="w-full !text-red-600 !text-[12px] mt-1">
                  <span className="w-4 h-4 mr-1 text-base leading-4 shrink-0">
                    <ErrorIcon fontSize="inherit" className="text-xs text-red-600 font-thin" />
                  </span>
                  <span>{errors.name}</span>
                </p>
              )}
            </>
          ) : (
            <p>{values.name}</p>
          )}
        </label>

        <label className="block">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-sm font-bold">説明文</span>
            {!readonly && (
              <span className="text-[10px] bg-red-50 text-red-500 px-1.5 py-0.5 rounded font-bold">必須</span>
            )}
          </div>
          {!readonly ? (
            <>
              <textarea
                className={`w-full rounded-xl border focus:outline-none focus:ring-2 focus:ring-blue-btn-primary/20 focus:border-blue-btn-primary min-h-[120px] p-4 text-base transition-colors
                ${errors.description ? 'border-red-500' : 'border-slate-200'}
              `}
                placeholder="メニューの詳細な説明を入力してください"
                name="description"
                value={values.description || ''}
                onChange={(e) => setFieldValue('description', e.target.value)}
                errors={errors.description}
              />
              {errors.description && (
                <p className="w-full !text-red-600 !text-[12px] mt-1">
                  <span className="w-4 h-4 mr-1 text-base leading-4 shrink-0">
                    <ErrorIcon fontSize="inherit" className="text-xs text-red-600 font-thin" />
                  </span>
                  <span>{errors.description}</span>
                </p>
              )}
            </>
          ) : (
            <p className="whitespace-pre-line">{values.description}</p>
          )}
        </label>

        <div className="grid grid-cols-2 gap-4">
          <label className="block">
            <p className="text-sm font-bold mb-2">カテゴリ</p>
            {!readonly ? (
              <SelectField
                name="category"
                value={values.category}
                setValue={(value) => setFieldValue('category', value)}
                options={CATEGORY_OPTIONS}
                inputClasses="w-full appearance-none rounded-xl border-slate-200 bg-slate-50 h-12 pr-10 text-sm transition-all"
                displayEmpty
                errors={errors.category}
              />
            ) : !values.category ? (
              <p>なし</p>
            ) : (
              <p>{CATEGORY_OPTIONS.find((c) => c.value === values.category).label}</p>
            )}
          </label>

          <label className="block">
            <p className="text-sm font-bold mb-2">施術時間</p>
            {!readonly ? (
              <SelectField
                name="treatmentTime"
                value={values.treatmentTime}
                setValue={(value) => setFieldValue('treatmentTime', value)}
                options={DURATION_OPTIONS.map((option) => ({
                  value: option.value,
                  id: option.value,
                  label: option.label,
                }))}
                inputClasses="w-full appearance-none rounded-xl border-slate-200 bg-slate-50 h-12 pr-10 text-sm transition-all"
                displayEmpty
                errors={errors.treatmentTime}
              />
            ) : !values.treatmentTime ? (
              <p>なし</p>
            ) : (
              <p>{DURATION_OPTIONS.find((c) => c.value === values.treatmentTime).label}</p>
            )}
          </label>
        </div>
      </div>
    </div>
  );
}
